<!--
 * @Author: czj
 * @Date: 2025-03-31 17:07:56
 * @Description: 
 * @FilePath: \sanshu-report-new\src\components\TableOfContents\TocItem\index.vue
-->
<template>
  <!-- :class="{ active: props.section.id === props.activeId }" -->
  <li class="toc-item">
    <div class="toc-item-header">

      <a :href="'#section-' + props.section.id" class="toc-link" :id="'toLink'+props.section.id">{{
        props.section.index}} {{ props.section.name}}</a>
      <span style="width: 20px;margin-right: 5px;">
        <el-icon style="vertical-align: middle;" class="toggle-icon" :class="{'expanded': isExpanded}"
          v-if="props.section.result && props.section.result.length > 0" @click.stop="toggleExpand">
          <ArrowRight />
        </el-icon>
      </span>
    </div>
    <ul v-if="isExpanded && props.section.result && props.section.result.length > 0" class="toc-list">
      <TocItem v-for="subsection in props.section.result" :key="subsection.id" :section="subsection"
        :level="props.level + 1" :activeId="props.activeId" />
    </ul>
  </li>
</template>
<script setup>
  import { ref, defineProps, defineEmits } from 'vue';
  import TocItem from './index.vue';
  const emit = defineEmits([])
  const props = defineProps({
    section: {
      type: Object,
      required: true
    },
    level: {
      type: Number,
      default: 1
    },
    activeId: {
      type: String,
    }
  });
  const isExpanded = ref(true); // 当前目录是否展开
  const toggleExpand = (event) => {// 切换目录展开状态
    console.log('toggleExpand', event);
    isExpanded.value = !isExpanded.value;
    event.stopPropagation();// 阻止事件冒泡,避免影响到 <a> 标签的点击
  };
</script>

<style scoped>
  .toc-item {
    margin-bottom: 8px;
  }

  .toc-link {
    text-decoration: none;
    color: #333;
    /* font-size: 0.9rem; */
    font-size: 16px;
    transition: color 0.2s;
    cursor: pointer;
  }

  .toggle-icon {
    /* margin-left: 10px; */
    cursor: pointer;
    transition: transform 0.3s ease-in-out;
  }

  .toggle-icon.expanded {
    transform: rotate(90deg);
  }

  .toc-list {
    transition: transform 0.3s ease-in-out, max-height 0.3s ease-in-out;
  }

  .toc-list ul {
    list-style: none;
    padding-left: 16px;
    /*   border-left: 2px solid #dee2e6; */
    margin-top: 8px;
  }

  .toc-item-header {
    display: flex;
    align-items: center;
  }

  .toc-item.active>.toc-item-header>.toc-link {
    color: var(--el-color-primary);
    /* 高亮色 */
    font-weight: bold;
  }
</style>